import client from "services/ngage/api-client";
import {AIContent, AIContentAPIData} from "../../types/AIContent";

/**
 * Create AI content
 */

async function create(data: AIContentAPIData) {
    const response = await client.post<AIContent>('/create-content', data);
    return response.data;
}

const aiContent = {
    create,
}

export default aiContent;